import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

export default class TextReveal {
    constructor(element) {
        this.element = element;
        this.elements = document.querySelectorAll("[data-reveal]");
        if (!this.elements.length) return;
        document.fonts.ready.then(() => this.init());
    }

    init() {
        this.elements.forEach(el => {
            const split = new SplitText(el, {
                type: "lines",
                linesClass: "line-wrap",
            });

            split.lines.forEach(line => {
                const inner = document.createElement("span");
                inner.className = "line-inner";
                inner.innerHTML = line.innerHTML;
                line.innerHTML = "";
                line.appendChild(inner);

                const lineHeight = line.getBoundingClientRect().height;
                gsap.set(inner, { y: lineHeight });
            });

            const inners = el.querySelectorAll(".line-inner");

            gsap.to(inners, {
                y: 0,
                ease: "power3",
                duration: 0.8,
                stagger: 0.15,
                scrollTrigger: {
                    trigger: el,
                    start: "top 60%",
                    once: true,
                }
            });
        });
    }
}